import type { OrderedMap } from '@gonfalon/immutable-shim/immutableShim';

import type { Environment } from '#utils/environments/records/Environment';
import type { Project } from '#utils/projects/records/Project';

export const getProjectForEnvById = (envId: string | undefined, projects: OrderedMap<string, Project>) =>
  projects.find((p) => !!envId && p.environments.includes(envId));

export const getProjectForEnv = (env: Environment, projects: OrderedMap<string, Project>) =>
  getProjectForEnvById(env._id, projects);
